export enum KsefSessionState{
    Initialized = 'Initialized',
    Completed = 'Completed',
    ReceivingUpo = 'ReceivingUpo',
    ReceivedUpo = 'ReceivedUpo',
    ErrorReceivingUpo = 'ErrorReceivingUpo'
}
